import { LabelColor } from "src/components/Label";

export const ActionTypeDict: { [id: string]: { color: LabelColor; icon: string } } = {
	STOCK: {
		color: "primary",
		icon: "mdi:chart-finance"
	},
	ETF: {
		color: "bluePurple",
		icon: "solar:chart-bold-duotone"
	},
	FUND: {
		color: "turquoise",
		icon: "icon-park-outline:funds"
	},
	REIT: {
		color: "info",
		icon: "pixelarticons:buildings"
	},
	CASH: {
		color: "success",
		icon: "fa6-solid:money-bill"
	},
	PP: {
		color: "pink",
		icon: "ph:piggy-bank-bold"
	},
	BOND: {
		color: "redFire",
		icon: "fa-solid:money-check"
	},
	RIGHTS: {
		color: "redFire",
		icon: "ph:ticket-bold"
	},
	UNKNOWN: {
		color: "black",
		icon: "carbon:unknown-filled"
	}
};
